module.exports = __webpack_public_path__ + "static/media/1020802.99d98bbf.png";